import React, { useState, useEffect, useRef } from "react";
import { gql, useQuery } from "@apollo/client";
import fondo from "../img-consultor-precios.jpeg";

const GET_PRODUCTOS = gql`
  query getProductos {
    getProductos {
      _id
      nombre
      codigo
      precio
      imagen
    }
  }
`;

function ConsultorDePrecios() {
  const { data, loading, error } = useQuery(GET_PRODUCTOS);

  const [input, setInput] = useState("");
  const [ultimoProducto, setUltimoProducto] = useState(null);

  const inputRef = useRef(null);

  // 🔹 Mantener foco SIEMPRE
  useEffect(() => {
    const interval = setInterval(() => {
      inputRef.current?.focus();
    }, 500);

    return () => clearInterval(interval);
  }, []);

  // 🔹 Borrar producto después de 5 segundos
  useEffect(() => {
    if (!ultimoProducto) return;

    const timer = setTimeout(() => {
      setUltimoProducto(null);
    }, 5000);

    return () => clearTimeout(timer);
  }, [ultimoProducto]);

  const buscarProducto = (codigo) => {
    if (!data?.getProductos) return;

    const producto = data.getProductos.find(
      (p) => p.codigo?.toString() === codigo.trim()
    );

    if (producto) {
      setUltimoProducto(producto);
    } else {
      setUltimoProducto(null);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      buscarProducto(input);
      setInput("");
      inputRef.current?.focus();
    }
  };

  if (loading) return <p>Cargando...</p>;
  if (error) return <p>Error cargando productos</p>;

  return (
    <div>
      {/* INPUT */}
      <input
        ref={inputRef}
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={handleKeyDown}
        autoFocus
        style={{
          width: "100%",
          padding: "15px",
          fontSize: "18px",
        }}
      />

      {/* FONDO CUANDO NO HAY PRODUCTO */}
      {!ultimoProducto && (
        <div
          style={{
            minHeight: "80vh",
            backgroundImage: `url(${fondo})`,
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "contain",
          }}
        ></div>
      )}

      {/* PRODUCTO */}
      {ultimoProducto && (
        <div className="container-fluid" >
          <div className="row ">

            {/* TEXTO */}
            <div className="col-sm-6 text-center text-md-start">
              <h2 style={{ fontSize: "clamp(24px, 4vw, 40px)" }}>
                {ultimoProducto.nombre}
              </h2>

              <h1 className="text-success fw-bold" style={{ fontSize: "clamp(40px, 8vw, 80px)" }}>
                ${ultimoProducto.precio}
              </h1>
            </div>

            {/* IMAGEN */}
            <div className="col-sm-6 text-center">
              <img
                src={ultimoProducto.imagen}
                alt={ultimoProducto.nombre}
                className="img-fluid"
                style={{ maxHeight: "400px" }}
              />
            </div>

          </div>
        </div>
      )}
    </div>
  );
}

export default ConsultorDePrecios;